import { D } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import { SignType } from "../../../domain";
import s from "./ActiveFilters.module.css";

const CloseIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function ActiveFilters({ filter, setFilter }) {
  const signedTypes = filter.signedType || {};
  const activeTypes = Object.keys(signedTypes).filter(
    (key) => signedTypes[key],
  );

  if (activeTypes.length === 0) {
    return null;
  }

  return (
    <div
      className={s.list}
      role="list"
      aria-label="Active signing type filters"
    >
      {activeTypes.map((signedType) => (
        <span key={signedType} className={s.chip} role="listitem">
          {SignType.toLabel(signedType)}
          <button
            type="button"
            className={s.deleteBtn}
            onClick={() => {
              setFilter(D.update("signedType", D.deleteKey(signedType)));
            }}
            aria-label={`Remove ${SignType.toLabel(signedType)} filter`}
          >
            <CloseIcon />
          </button>
        </span>
      ))}
    </div>
  );
}

ActiveFilters.propTypes = {
  filter: PropTypes.shape({
    signedType: PropTypes.object,
  }).isRequired,
  setFilter: PropTypes.func.isRequired,
};
